import Fab from '@material-ui/core/Fab';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  Wrapper: params => ({
    ...{
      alignItems: 'center',
      height: params.size ? `${params.size}px` : `${25}px`,
      minHeight: params.size ? `${params.size}px` : `${25}px`,
      width: params.size ? `${params.size}px` : `${25}px`,
      transition: 'color 0.25s',
      '&:hover span': {
        color: theme.palette.white,
      },
    },
    ...params.position,
  }),
  CircleButton: {
    zIndex: 1401,
    padding: 0,
    margin: 0,
    width: 25,
    height: 25,
    minWidth: 'initial',
    backgroundColor: theme.palette.green,
    border: '2px solid',
    borderColor: theme.palette.white,
    borderRadius: '50%',
    color: theme.palette.black,
    transition: 'color 0.25s',
    '& svg': {
      width: 15,
      height: 15,
    },
  },
}));

const CircleButton = props => {
  const { toolTipText, onClickFunction, PassedIcon, size, position } = props;
  const classes = useStyles({ size, position });
  return (
    <Tooltip title={toolTipText || ''} aria-label="add">
      <Fab onClick={() => onClickFunction()} className={classes.Wrapper}>
        <span className={`${classes.CircleButton}`}>{PassedIcon}</span>
      </Fab>
    </Tooltip>
  );
};

CircleButton.propTypes = {
  toolTipText: PropTypes.string,
  onClickFunction: PropTypes.func,
  PassedIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  size: PropTypes.number,
  position: PropTypes.object,
};

export default CircleButton;
